import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'

import Footer from './footer'

import { showModal } from 'actions/common'

export class FooterContainer extends Component {

  render() {
    return (
      <Footer showModal={this.props.showModal} />
    )
  }

}

FooterContainer.propTypes = {
  showModal: PropTypes.func,
}

const mapDispatchToProps = { showModal }

export default connect(null, mapDispatchToProps)(FooterContainer)



/** WEBPACK FOOTER **
 ** ./src/components/footer/footer-container.js
 **/